module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapnum"
  }, [_c('a', {
    attrs: {
      "id": "c03"
    }
  }), _vm._v("3")]), _vm._v(" "), _c('h1', {
    staticClass: "chaptitle"
  }, [_vm._v("A Faith-Filled Life")]), _vm._v(" "), _c('p', {
    staticClass: "epiv"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('i', [_vm._v("Faith is not about everything turning out okay. It's about being okay, no matter how everything turns out")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "eps"
  }, [_vm._v("—Anonymous")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("I didn't grow up in a faith-filled home. I never observed anyone at 827 being quietly peaceful, trusting that the experiences we were sharing would work out okay. The days and nights were generally very tense, undergirded with the expectation that an outburst over something, large or small, imagined even, might occur at any moment. And usually did. Night after night, the feeling present at the supper table mimicked the feeling at lunch. Tension was served and felt with each bite. Our family doctor, Dr. Cole, told my mother that I had a nervous stomach. What I really had was extreme anxiety that made eating nearly impossible some nights. Living in my home was hard. Peace was something I could never have defined. Tension was all I knew. Tension defined all six of us.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("I did have a place I loved to be, though, and that was in Logansport with my grandparents. My grandmother had a quiet presence about her. No wonder I loved to visit them. Her comforting words and arms and smiles would temporarily convince me that everything was okay. When I thought about home when I was with her, my stomach would twist and turn. I hated to feel, even from afar, the tension at home. I feared it would never change. And as a matter of fact, it never did. Not even with the passage of time. Tension was as fresh "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("in my parents' old age as when they were young. How tragic, really.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Tension is hard on all of us. No matter our age. But we choose the feeling, as strange as that may seem. Unfortunately, we seldom understand how and when we made that choice. Certainly I didn't know I had chosen it. We do imitate that which we observe, however. And my times with my grandmother were simply too short for me to adapt to her way of living and seeing the world.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("For many who grew up in environments like mine, leaving home, choosing to be surrounded by new philosophies, new people, new opportunities, became necessary in order to catch a glimpse of a life free from tension. And that glimpse didn't come very quickly for me. It took a few years, a few bad relationships, one painful marriage, and multiple suicide considerations before I was solidly awakened to a better choice, a saner perspective, a softer, kinder feeling within. What brought me to this new experience of faith, this place of wellbeing, was two decades of near constant alcohol and drug use that could have ended my life. But I reached that new place. I arrived at a saner, faith-filled place with the help of friends who had been sent to make sure I'd arrive. The place had a name; it was called Alcoholics Anonymous.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("I don't mean to suggest that anyone else needs to travel my path to find faith, to reach that peaceful place of knowing that everything is okay. But that's what I had to do. We can get here following any number of paths. There is no right one. The goal is just to seek a path until you find it, then travel it, share what you know if someone expresses an interest, model faith for others without making a point of it, and give it away when you can so that it can be kept. Having faith is like having the gold ring in your pocket that you grabbed on the merry-go-round when you were a child. That ring promised you another ride "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("whenever you wanted to claim it. Like faith, it would always be there. And even when you used it, you knew another gold ring was yours for the taking.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("It's funny, really; I don't even ponder my faith any longer. I simply live it. I never doubt that God is present, that all is well, that what I need to experience will come calling, that who I need to meet might be around the next bend in the road. Even when I don't like what might be happening, I know that what is happening is the next right experience for me. My faith has taught me that. Again and again. And life feels simple and calm and intentional. Most of all, it feels purposeful. I do what's on the chart for me, and God is pleased. This I believe.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U001.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("Are you at peace?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("Has your life measured up in the way you had hoped it would?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("Do you long for a more faith-filled life?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("It's not too late to create it. Here are some suggestions that I can vouch for. Maybe one or two will appeal to you:")]), _vm._v(" "), _c('p', {
    staticClass: "text3"
  }, [_vm._v("1. Make a list of what you are grateful for in your life. How has each one made you a better person?")]), _vm._v(" "), _c('p', {
    staticClass: "text3"
  }, [_vm._v("2. Make a practice of having a short conversation with God each morning, either right before your feet hit the floor or right after.")]), _vm._v(" "), _c('p', {
    staticClass: "text3"
  }, [_vm._v("3. Ask him for his help in everything you are called on to do.")]), _vm._v(" "), _c('p', {
    staticClass: "text3"
  }, [_vm._v("4. Be prepared to thank God throughout the day for all of the little miracles that seem to be happening, miracles you might not have noticed before.")]), _vm._v(" "), _c('p', {
    staticClass: "text3"
  }, [_vm._v("5. Be ready and willing to help the first person you meet. At the very least, greet him or her with a smile.")]), _vm._v(" "), _c('p', {
    staticClass: "text3"
  }, [_vm._v("6. "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("And if you are still failing to connect with God, write him a note and ask for help.")]), _vm._v(" "), _c('p', {
    staticClass: "text3"
  }, [_vm._v("7. Share with your closest friend a few of the events in your life when God “showed up.”")]), _vm._v(" "), _c('p', {
    staticClass: "text3"
  }, [_vm._v("8. Keep a list of these special experiences close at hand for those times that you doubt his availability.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("Now relax. God is in charge and he doesn't need your help today.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U001.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8854e33a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/09_chapter-03.vue
// module id = 84
// module chunks = 0